import _ from 'lodash';

import { TODOS_OVERVIEW } from '../actions/actionTypes';

const initialState = {
  result: [],
  meta: {
    numberOfDocuments: 0,
    isLoading: true,
    error: null,
  },
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case TODOS_OVERVIEW.FETCH.REQUEST:
      return {
        ...state,
        meta: {
          ...state.meta,
          isLoading: true,
        },
      };
    case TODOS_OVERVIEW.FETCH.SUCCESS:
      return {
        result: _.chain(action)
          .get(['payload', 'todos', 'result'])
          .map('_id')
          .value(),
        meta: {
          ...state.meta,
          numberOfDocuments: _.chain(action)
            .get(['payload', 'todos', 'meta', 'numberOfDocuments'])
            .value(),
          isLoading: false,
          error: null,
        },
      };
    case TODOS_OVERVIEW.FETCH.ERROR:
      return {
        result: [],
        meta: {
          ...state.meta,
          numberOfDocuments: 0,
          isLoading: false,
          error: _.get(action, ['payload', 'error']),
        },
      };
    case TODOS_OVERVIEW.CLEAR:
      return initialState;
    default:
      return state;
  }
}
